import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectsDirectoryPageResource } from '@jira/router-resources__project-directory-v3/src/projectsDirectoryPageResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { homepageLayout } from '@jira/platform__layouts-homepage-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectsDirectoryRedirectRoute } from '@jira/router-routes__directories-routes/src/projectsDirectoryRedirectRoute.tsx';
import { ProjectsDirectorySkeleton } from '@jira/platform__skeletons/src/ui/directories/FiltersDirectorySkeleton.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { ProjectsDirectoryRedirect } from './ui/ProjectsDirectoryRedirect.tsx';
import { LazyProjectsDirectory } from './common/LazyProjectsDirectory.tsx';

export const projectsDirectoryRedirectRouteEntry: Route = createEntry(
	projectsDirectoryRedirectRoute,

	() => ({
		group: 'directories',
		// eslint-disable-next-line no-restricted-syntax
		component: ProjectsDirectoryRedirect,
		skeleton: ProjectsDirectorySkeleton,
		isRedirect: true,
		layout: homepageLayout,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [...getNavigationResources(), projectsDirectoryPageResource],
		forPaint: [LazyAtlassianNavigation, LazyProjectsDirectory],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
